import React, { useReducer } from 'react';
import SummaryProvider, {
  useAppliedFilter,
  useUnsuitedFilter,
  useFilterChanges,
  useFilterSummary,
} from './SummaryProvider';
import ActionsProvider, {
  reducer,
  useLegFilterActions,
  useFilterActions,
} from './ActionsProvider';
import PredicateProvider, { usePredicate } from './PredicateProvider';
import StateProvider, {
  useLegFilterState,
  useAvailableFilterState,
  useIsAbleToBeUnfiltered,
} from './StateProvider';

const AirportFilterProvider = ({ children }) => {
  const [airports, dispatch] = useReducer(reducer, null);

  return (
    <StateProvider airports={airports}>
      <PredicateProvider>
        <ActionsProvider dispatch={dispatch}>
          <SummaryProvider>{children}</SummaryProvider>
        </ActionsProvider>
      </PredicateProvider>
    </StateProvider>
  );
};

export default AirportFilterProvider;

export {
  useLegFilterState as useAirportLegFilterState,
  useIsAbleToBeUnfiltered as useAirportFilterIsAbleToBeUnfiltered,
  useAvailableFilterState as useAvailableAirports,
  useFilterActions as useAirportFilterActions,
  usePredicate as useAirportFilterPredicate,
  useAppliedFilter as useAppliedAirportFilter,
  useUnsuitedFilter as useUnsuitedAirportFilter,
  useFilterSummary as useAirportFilterSummary,
  useLegFilterActions as useAirportLegFilterActions,
  useFilterChanges as useAirportFilterChanges,
};
